/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateExport } from '@coin/shared/core/util-models-v2';
import { CreateMercerStandingComment } from '@coin/shared/core/util-models-v2';
import { MercerStandingComment } from '@coin/shared/core/util-models-v2';
import { MercerStandingDashboardValues } from '@coin/shared/core/util-models-v2';
import { MercerStandingDetails } from '@coin/shared/core/util-models-v2';
import { MercerStandingValidationResponse } from '@coin/shared/core/util-models-v2';
import { PageOfMercerStandingEmployeeData } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateMercerStanding } from '@coin/shared/core/util-models-v2';
import { ValidateMercerStandingInput } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface ExportMercerStandingsPartnerParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: Array<boolean>;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected' | 'Review'>;
  wasPromoted?: Array<boolean>;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  createExport?: CreateExport;
}

export interface GetDashboardValuesMercerStandingsPartnerParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: Array<boolean>;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected' | 'Review'>;
  wasPromoted?: Array<boolean>;
}

export interface GetForMeritMercerStandingsPartnerParams {
  /**  */
  employeeId: string;
  /**  */
  seasonId: string;
}

export interface GetMercerStandingsPartnerParams {
  /**  */
  employeeId: string;
}

export interface MercerStandingPartnerCreateMercerStandingCommentsParams {
  /** The unique id of the employee to create a comment for. */
  employeeId: string;
  /** The model data to create the comment with. */
  createMercerStandingComment?: CreateMercerStandingComment;
}

export interface MercerStandingPartnerQueryMercerStandingCommentsParams {
  /** The unique id of the employee to query comments for. */
  employeeId: string;
}

export interface QueryFieldValuesMercerStandingsPartnerParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: boolean;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected' | 'Review'>;
  page?: number;
  size?: number;
}

export interface QueryMercerStandingsPartnerParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: Array<boolean>;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected' | 'Review'>;
  wasPromoted?: Array<boolean>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface UpdateMercerStandingsPartnerParams {
  /**  */
  employeeId: string;
  /**  */
  updateMercerStanding?: UpdateMercerStanding;
}

export interface ValidateMercerStandingsPartnerParams {
  /**  */
  employeeId: string;
  /**  */
  validateMercerStandingInput?: ValidateMercerStandingInput;
}

@Injectable({
  providedIn: 'root'
})
export class MercerStandingPartnerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMercerStandingsPartner(
    requestParameters?: ExportMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMercerStandingsPartner(
    requestParameters?: ExportMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMercerStandingsPartner(
    requestParameters?: ExportMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMercerStandingsPartner(
    requestParameters?: ExportMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/mercer-standing/partner/api/employees/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Search: requestParameters?.search,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        IsHead: requestParameters?.isHead,
        Gid: requestParameters?.gid,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        PositionClass: requestParameters?.positionClass,
        MercerJobCode: requestParameters?.mercerJobCode,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        LineManagerGid: requestParameters?.lineManagerGid,
        ValidationState: requestParameters?.validationState,
        WasPromoted: requestParameters?.wasPromoted,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.createExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Get values for the quick filters in the list view of standing position evaluation HR BP app
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: GetDashboardValuesMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDashboardValues>;
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: GetDashboardValuesMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDashboardValues>>;
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: GetDashboardValuesMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDashboardValues>>;
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: GetDashboardValuesMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/partner/api/employees/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Search: requestParameters?.search,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        IsHead: requestParameters?.isHead,
        Gid: requestParameters?.gid,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        PositionClass: requestParameters?.positionClass,
        MercerJobCode: requestParameters?.mercerJobCode,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        LineManagerGid: requestParameters?.lineManagerGid,
        ValidationState: requestParameters?.validationState,
        WasPromoted: requestParameters?.wasPromoted
      }
    });
  }

  /**
   * Returns MercerStanding for partner app of merit.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getForMeritMercerStandingsPartner(
    requestParameters?: GetForMeritMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public getForMeritMercerStandingsPartner(
    requestParameters?: GetForMeritMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public getForMeritMercerStandingsPartner(
    requestParameters?: GetForMeritMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public getForMeritMercerStandingsPartner(
    requestParameters?: GetForMeritMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getForMeritMercerStandingsPartner', { employeeId, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Returns MercerStanding for partner app of standing position evaluation.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMercerStandingsPartner(
    requestParameters?: GetMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public getMercerStandingsPartner(
    requestParameters?: GetMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public getMercerStandingsPartner(
    requestParameters?: GetMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public getMercerStandingsPartner(
    requestParameters?: GetMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getMercerStandingsPartner', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Creates a new employee comment for mercer standing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public mercerStandingPartnerCreateMercerStandingComments(
    requestParameters?: MercerStandingPartnerCreateMercerStandingCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingComment>;
  public mercerStandingPartnerCreateMercerStandingComments(
    requestParameters?: MercerStandingPartnerCreateMercerStandingCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingComment>>;
  public mercerStandingPartnerCreateMercerStandingComments(
    requestParameters?: MercerStandingPartnerCreateMercerStandingCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingComment>>;
  public mercerStandingPartnerCreateMercerStandingComments(
    requestParameters?: MercerStandingPartnerCreateMercerStandingCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('mercerStandingPartnerCreateMercerStandingComments', { employeeId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMercerStandingComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets all comments made for this employee in mercerStanding context. This is not for a specific mercerStanding object but for the employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public mercerStandingPartnerQueryMercerStandingComments(
    requestParameters?: MercerStandingPartnerQueryMercerStandingCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<MercerStandingComment>>;
  public mercerStandingPartnerQueryMercerStandingComments(
    requestParameters?: MercerStandingPartnerQueryMercerStandingCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<MercerStandingComment>>>;
  public mercerStandingPartnerQueryMercerStandingComments(
    requestParameters?: MercerStandingPartnerQueryMercerStandingCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<MercerStandingComment>>>;
  public mercerStandingPartnerQueryMercerStandingComments(
    requestParameters?: MercerStandingPartnerQueryMercerStandingCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('mercerStandingPartnerQueryMercerStandingComments', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Queries field values for the list view of standing position evaluation HR BP app
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: QueryFieldValuesMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: QueryFieldValuesMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: QueryFieldValuesMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: QueryFieldValuesMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('queryFieldValuesMercerStandingsPartner', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/partner/api/employees/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        Search: requestParameters?.search,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        IsHead: requestParameters?.isHead,
        Gid: requestParameters?.gid,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        PositionClass: requestParameters?.positionClass,
        MercerJobCode: requestParameters?.mercerJobCode,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        LineManagerGid: requestParameters?.lineManagerGid,
        ValidationState: requestParameters?.validationState,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Returns all employees with their LineManager and MercerStanding for the list view of standing position evaluation HR BP app.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerStandingsPartner(
    requestParameters?: QueryMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMercerStandingEmployeeData>;
  public queryMercerStandingsPartner(
    requestParameters?: QueryMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMercerStandingEmployeeData>>;
  public queryMercerStandingsPartner(
    requestParameters?: QueryMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMercerStandingEmployeeData>>;
  public queryMercerStandingsPartner(
    requestParameters?: QueryMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/partner/api/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Search: requestParameters?.search,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        IsHead: requestParameters?.isHead,
        Gid: requestParameters?.gid,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        PositionClass: requestParameters?.positionClass,
        MercerJobCode: requestParameters?.mercerJobCode,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        LineManagerGid: requestParameters?.lineManagerGid,
        ValidationState: requestParameters?.validationState,
        WasPromoted: requestParameters?.wasPromoted,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * &lt;p&gt;Update MercerStanding for partner app of standing position evaluation.&lt;/p&gt; &lt;p&gt;Only available for hr, c&amp;b or admins.&lt;/p&gt;
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerStandingsPartner(
    requestParameters?: UpdateMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public updateMercerStandingsPartner(
    requestParameters?: UpdateMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public updateMercerStandingsPartner(
    requestParameters?: UpdateMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public updateMercerStandingsPartner(
    requestParameters?: UpdateMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateMercerStandingsPartner', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMercerStanding,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Check whether the position class or job code is the same or higher than that of the line manager
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateMercerStandingsPartner(
    requestParameters?: ValidateMercerStandingsPartnerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingValidationResponse>;
  public validateMercerStandingsPartner(
    requestParameters?: ValidateMercerStandingsPartnerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingValidationResponse>>;
  public validateMercerStandingsPartner(
    requestParameters?: ValidateMercerStandingsPartnerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingValidationResponse>>;
  public validateMercerStandingsPartner(
    requestParameters?: ValidateMercerStandingsPartnerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('validateMercerStandingsPartner', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/validate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.validateMercerStandingInput,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
